/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import SiteConfigPermissions from './permissions/site.config';
import SponsorConfigPermissions from './permissions/sponsor.config';
import ParticipantDocumentsConfigPermissions from './permissions/participant.documents.config';

/**
 * role types configurations
 *
 * Important priority of roles must from bottom to top
 *
 * For example sponsor permissions will overwrite site permissions config type
 */
const config_types = {
  sponsor: ['CRFB_SUPER_USER', 'SPONSOR_SUPER_USER'],
  sponsor_personnel: ['CRFB_SUPER_USER', 'SPONSOR_SUPER_USER', 'SPONSOR_STUDY_MANAGER', 'SPONSOR_REVIEWER'],
  site: ['INVESTIGATOR'],
  documents: ['INVESTIGATOR', 'SITE_USER']
};

// endpoint for user roles was removed in backend
// temporary leaving all actions available in client
const PERMISSIONS_MATRIX = {
  'super-admin': true,
  pages: {
    view: true
  },
  'role-delegation': {
    actions: {
      add: true,
      edit: true,
      delete: true
    }
  },
  reports: {
    actions: {
      download: true
    }
  },
  notes: {
    /** TODO **/
  },
  documents: {
    actions: {
      add: true
    }
  }
};

/**
 * RoleService resolves the permissions and access rights for pages and features
 * related to a user role
 *
 * Permissions and Roles are configured in a declarative way
 */
class RoleService {
  constructor(types) {
    this.types = types;
  }

  isSuperAdmin(userRoles) {
    for (let role of userRoles) {
      if (role.name === 'CRFB_SUPER_USER') {
        return { 'super-admin': true };
      }
    }
    return {};
  }

  /**
   *
   * @description when the user role match one roles type configuration
   * the matrix will be updated with the specified permissions
   *
   * @param role
   * @returns {matrix}
   */
  getRoleDelegationPermissions(userRoles) {
    let permissions = {};

    for (let role of userRoles) {
      if (this.types.site.includes(role.name)) {
        permissions = Object.assign(permissions, SiteConfigPermissions['role-delegation']);
      }

      if (this.types.sponsor.includes(role.name)) {
        permissions = Object.assign(permissions, SponsorConfigPermissions['role-delegation']);
      }
    }

    return permissions;
  }

  getParticipantDocumentsPermissions(userRoles) {
    let permissions = {};
    for (let role of userRoles) {
      if (this.types.documents.includes(role.name)) {
        permissions = Object.assign({}, permissions, ParticipantDocumentsConfigPermissions['documents']);
      }
    }
    return permissions;
  }

  getStudyReportsPermissions(userRoles) {
    let permissions = {};
    for (let role of userRoles) {
      if (this.types.sponsor_personnel.includes(role.name)) {
        permissions = Object.assign({}, permissions, SponsorConfigPermissions['reports']);
      }
    }
    return permissions;
  }

  getMatrix(/* userRoles */) {
    let matrix = Object.assign(
      {},
      PERMISSIONS_MATRIX
      // this.getParticipantDocumentsPermissions(userRoles),
      // this.isSuperAdmin(userRoles),
      // this.getRoleDelegationPermissions(userRoles),
      // this.getStudyReportsPermissions(userRoles)
    );
    return matrix;
  }
}

const RoleServiceInstance = new RoleService(config_types);

export { RoleServiceInstance, PERMISSIONS_MATRIX };
